import React from "react";

export const partnersFaqEntries = [
  {
    question: "Preciso ter experiência no setor de energia?",
    answer:
      "Não. O programa foi pensado para receber pessoas de diferentes áreas. Fornecemos treinamento e materiais de apoio para que você tenha segurança na prospecção e no relacionamento com clientes.",
  },
  {
    question: "Como funciona a remuneração do Parceiro?",
    answer:
      "O parceiro recebe uma comissão de até 5% sobre o valor pago pelo cliente à Energea. É um modelo de receita recorrente: enquanto o cliente permanecer ativo, você continua recebendo mensalmente.",
  },
  {
    question: "Posso atuar em meio período?",
    answer:
      "Sim. Muitos parceiros começam dedicando algumas horas por semana e ampliam sua atuação conforme a carteira de clientes cresce.",
  },
  {
    question:
      "Onde a Energea já possui usinas ativas prontas para receber clientes?",
    answer:
      "Atualmente temos usinas em operação no Rio de Janeiro (Light), em Minas Gerais (CEMIG), em Nova Friburgo - RJ (Energisa) e em Goiás (Equatorial), todas prontas para receber novos clientes.",
  },
  {
    question: "A parceria tem restrições regionais?",
    answer:
      "Nosso objetivo é expandir em várias regiões, mas priorizamos áreas estratégicas e limitamos o número de parceiros por cidade para garantir qualidade no atendimento.",
  },
  {
    question: "Qual é o investimento necessário para começar?",
    answer:
      "Não há necessidade de investimento em estrutura ou estoque. O Parceiro precisa apenas de dedicação, proatividade e conexão com pessoas e empresas. O suporte comercial fica por conta da Energea.",
  },
  {
    question: "Existe contrato ou vínculo empregatício?",
    answer:
      "Não. O Parceiro atua de forma independente, com flexibilidade de horários, mas com o respaldo de uma marca sólida no mercado de energia limpa.",
  },
  {
    question: "Como funciona o processo de cadastro?",
    answer:
      "O parceiro realiza o cadastro pelo portal, escolhe o tipo de parceria e envia os documentos necessários. Após análise, recebe a confirmação do status.",
  },
  {
    question: "Quais são os status possíveis no processo de aprovação?",
    answer: (
      <React.Fragment>
        <ul>
          <li>Em análise - Documentos em revisão pela equipe Energea.</li>
          <li>Credenciado - Cadastro aprovado, contrato assinado e parceria ativa.</li>
          <li>Reprovado - Documentos não validados.</li>
          <li>Cancelado - Parceria encerrada.</li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    question: "Em quanto tempo começo a receber?",
    answer:
      "A sua comissão começa a ser contabilizada assim que o cliente indicado concluir a adesão e tiver a primeira fatura ativa. Vale lembrar que o prazo para que o cliente comece a receber a injeção dos nossos créditos de energia é de até 90 dias.",
  },
  {
    question: "Preciso vender apenas para conhecidos?",
    answer:
      "Não. Fornecemos ferramentas e estratégias de prospecção para que você alcance novos clientes de forma profissional, expandindo sua rede além dos contatos pessoais.",
  },
  {
    question: "Como recebo minhas comissões?",
    answer:
      "O pagamento é feito mensalmente, diretamente em sua conta bancária, de forma transparente e com relatórios acessíveis no nosso sistema.",
  },
  {
    question: "Quais são os diferenciais da Energea para meus clientes?",
    answer:
      "Além da economia imediata na conta de luz, nossos clientes têm a confiança de uma empresa especializada em energia limpa e a tranquilidade de um atendimento próximo e personalizado.",
  },
];
